import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Divider
} from '@mui/material';
import { theme } from '../../../theme';

interface ProfileNavBarPopupProps {
  name?: string;
  email?: string;
  open: boolean;
  onClose: () => void;
  onProfileEditClick: () => void;
  handleLogout: () => void;
}

const ProfileNavBarPopup: React.FC<ProfileNavBarPopupProps> = ({
  name,
  email,
  open,
  onClose,
  onProfileEditClick,
  handleLogout,
}) => {
  const popupRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        onClose();
      }
    };
  
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }
  
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, onClose]);
  
  return (
    <>
      <Paper
        ref={popupRef}
        sx={{
          width: 'fit-content',
          position: 'absolute',
          border: 'none',
          boxShadow: '0px 20px 50px -20px rgba(0, 0, 0, 0.5)',
          top: open ? '60px' : '50px',
          right: '30px',
          borderRadius: '12px 12px 8px 8px',
          opacity: open ? 1 : 0,
          display: 'block',
          transition: 'opacity 0.3s ease, top 0.3s ease',
          pointerEvents: open ? 'auto' : 'none',
          zIndex: 1300,
        }}
        elevation={3}
      >
        <Box p={2} pb={0}>
          <Typography
            sx={{
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '4px',
              cursor: 'pointer',
            }}
            onClick={onProfileEditClick}
          >
            {name ?? 'User Name'}
          </Typography>
          <Typography
            sx={{
              fontSize: '12px',
              color: '#6B7280',
              marginBottom: '8px',
              cursor: 'pointer',
            }}
            onClick={onProfileEditClick}
          >
            {email ?? 'Email Address'}
          </Typography>
          <Divider />
          <Button
            variant="text"
            size="small"
            sx={{
              color: theme.palette.text.primary,
              justifyContent: 'start',
              p: 1,
              ':hover': {
                bgcolor: 'transparent',
              },
            }}
            onClick={handleLogout}
            fullWidth
            endIcon={
              <Box pl={1}>
                <i className="fa-solid fa-arrow-right-from-bracket"></i>
              </Box>
            }
          >
            <Typography variant="subtitle1">Log Out</Typography>
          </Button>
        </Box>
      </Paper>
    </>
  );
};

export default ProfileNavBarPopup;
